import styled, { css } from "styled-components";
import { colors } from "../../theme/colors";
import { Text } from "../Text/Text.component";
import { TextInputProps, TextInputWrapperProps } from "./types";

export const Label = styled.label<{ color?: string }>`
    color: ${({ color }) => color || ""};
    font-size: 12px;
    font-weight: 600;
`;

export const TextInputWrapper = styled("div")<TextInputWrapperProps>`
    ${Label} {
        color: ${({ focus, error, disabled }) =>
            error
                ? colors.red.primary
                : focus
                ? colors.purple.primary
                : disabled
                ? colors.grey.secondary
                : colors.grey.primary};
    }

    width: ${({ fullWidth }) => (fullWidth ? "100%" : "min-content")};
    min-width: ${({ minWidth }) => minWidth};
    max-width: ${({ maxWidth }) => maxWidth};
`;

const borderStyle = (focus: boolean, error: boolean) => {
    if (error) {
        return css`
            border-color: ${colors.red.primary};
        `;
    } else if (focus) {
        return css`
            border-color: ${colors.purple.primary};
        `;
    }
};

export const UpperTextWrapper = styled("div")``;

export const StyledTextInput = styled("input")<TextInputProps>`
    display: block;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    background-color: ${({ bgColor }) => bgColor || colors.grey.tertiary};
    /* padding: ${({ multiLine }) => (multiLine ? "10px" : "0 10px")}; */
    font-family: "Montserrat", sans-serif;
    font-weight: 500;
    padding: 10px;
    resize: none;
    height: 38px;
    width: 100%;
    padding-right: 30px;
    line-height: 16px;
    outline: none;
    height: ${({ multiLine }) => (multiLine ? "100px" : "initial")};
    position: relative;

    &::placeholder {
        color: ${colors.grey.secondary};
        font-family: "Montserrat", sans-serif;
    }

    &[type="password"] {
        font-size: 16px;
        line-height: 16px;
    }

    &:disabled {
        cursor: not-allowed;
        ${Label.Style} {
            cursor: not-allowed;
        }
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    &[type="number"] {
        -moz-appearance: textfield;
        appearance: textfield;
    }
`;

export const InnerWrapper = styled.div<{
    focus: boolean;
    error: boolean;
    bgColor?: string;
}>`
    margin-top: 8px;
    border-radius: 8px;
    width: 100%;
    background-color: ${({ bgColor }) => bgColor || colors.grey.tertiary};
    border: 1px solid ${colors.grey.tertiary};
    ${({ focus, error }) => borderStyle(focus, error)};
    display: flex;
    align-items: center;
    transition: 0.2s border-color ease-in-out;
    position: relative;
    /* & > textarea {
        font-family: "Montserrat", sans-serif;
    } */
`;

export const RequiredIcon = styled("span")`
    color: ${colors.red.primary};
    font-size: 11px;
    font-weight: 500;
`;

export const PasswordButton = styled("img")`
    width: 16px;
    margin: 10px;
    cursor: pointer;
    position: absolute;
    right: 0;
`;

export const ErrorMsg = styled(Text)`
    color: ${colors.red.primary};
    display: inline-block;
    margin: 5px;
`;

export const SuffixWrapper = styled.div`
    display: inline-block;
    margin: 0 10px;
    position: absolute;
    right: 0;
    cursor: pointer;
`;
